<template>
  <div class="nebPaginator">
    <div class="nebPaginator-pageText">
      <span>Page</span>
    </div>

    <div class="nebPaginator-input"
      :class="currentPage > 9 ? 'large' : ''"
    >
      <neb-input placeholder=""
        :value="String(currentPage)"
        @input="onInput"
      ></neb-input>
    </div>

    <div class="nebPaginator-ofText">
      <span>of {{ totalPages }}</span>
    </div>

    <div class="nebPaginator-controls">
      <neb-control grouped>
        <neb-control>
          <neb-icon-button icon="caretLeft"
            :disabled="currentPage === 1"
            @click="onPrevClick"
          ></neb-icon-button>
        </neb-control>

        <neb-control>
          <neb-icon-button icon="caretRight"
            :disabled="currentPage === totalPages"
            @click="onNextClick"
          ></neb-icon-button>
        </neb-control>
      </neb-control>
    </div>
  </div>
</template>

<script>
import { isNumber } from 'lodash'

import NebInput from '../Input'
import NebIconButton from '../IconButton'
import NebControl from '../Control'

export default {
  name: 'NebPaginator',

  components: {
    NebInput,
    NebIconButton,
    NebControl
  },

  props: {
    currentPage: {
      type: Number,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    }
  },

  computed: {
    totalPages () {
      return Math.ceil(this.totalCount / this.pageSize)
    }
  },

  methods: {
    isValid (value) {
      return isNumber(value) &&
        value > 0 &&
        value <= this.totalPages
    },
    onPrevClick () {
      if (!this.isValid(this.currentPage - 1)) { return }

      this.$emit('change', this.currentPage - 1)
    },
    onNextClick () {
      if (!this.isValid(this.currentPage + 1)) { return }

      this.$emit('change', this.currentPage + 1)
    },
    onInput (value) {
      const parsed = parseInt(value)

      if (!this.isValid(parsed)) { return }

      this.$emit('change', parsed)
    }
  }
}
</script>

<style lang="scss">
@import '../../style.scss';

.nebPaginator {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &-pageText,
  &-ofText {
    span {
      font-family: $defaultFont;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: $slate-grey;
    }
  }

  &-input,
  &-ofText,
  &-controls {
    margin-left: 5px;
  }

  .nebInput {
    input {
      width: 34px;
      padding-left: 11px;
      padding-right: 11px;
    }
  }

  &-input {
    &.large {
      .nebInput {
        input {
          width: 50px;
        }
      }
    }
  }
}
</style>
